module.exports = __webpack_public_path__ + "images/2db8b127ce0d7cbfe95128d4dfa80c231.svg";